export const lightStrongAdditional = "#33adff";
export const darkStrongError = "#ff2e4b";
